var map = {
	"./avatar.svg": "a692",
	"./congrats.svg": "9551",
	"./first.svg": "a262",
	"./fourth.svg": "b184",
	"./girl.svg": "d06f",
	"./homepage.svg": "8cf7",
	"./initial.svg": "b855",
	"./last.svg": "5a6d",
	"./men.svg": "3791",
	"./recycle.svg": "7447",
	"./reduce-refuse/buy.svg": "4d62",
	"./reduce-refuse/gift.svg": "5174",
	"./reduce-refuse/laundry.svg": "5fdd",
	"./reduce-refuse/minimal.svg": "0158",
	"./reduce-refuse/observe.svg": "eb6b",
	"./reduce-refuse/walk.svg": "51f3",
	"./reduce.svg": "83d1",
	"./refuse.svg": "33a5",
	"./reuse-people.svg": "6655",
	"./reuse.svg": "b4c7",
	"./reuse/purchase.svg": "cd8f",
	"./reuse/rental.svg": "81e5",
	"./reuse/repair.svg": "5cb3",
	"./reuse/reuse-people.svg": "6b7e",
	"./reuse/reuse.svg": "7fbd",
	"./reuse/second-hand.svg": "5dee",
	"./rot.svg": "0911",
	"./second.svg": "a62d",
	"./swaps/coffee-cup.svg": "b75d",
	"./swaps/food-bag.svg": "cfb8",
	"./swaps/lunch-box.svg": "6ba0",
	"./swaps/water.svg": "963e",
	"./third.svg": "403d",
	"./timeout.svg": "944d",
	"./tree.svg": "aaec",
	"./waste/bio.svg": "4f02",
	"./waste/electro.svg": "34b0",
	"./waste/glass.svg": "2af1",
	"./waste/metal.svg": "77b6",
	"./waste/paper.svg": "b134",
	"./waste/plastic.svg": "4fcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";